module.exports = __webpack_public_path__ + "img/edit.d766781a.svg";